import { render, staticRenderFns } from "./Resetpwd.vue?vue&type=template&id=56f1ec4e&scoped=true&"
import script from "./Resetpwd.vue?vue&type=script&lang=js&"
export * from "./Resetpwd.vue?vue&type=script&lang=js&"
import style0 from "./Resetpwd.vue?vue&type=style&index=0&id=56f1ec4e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f1ec4e",
  null
  
)

export default component.exports